import RectangleImage1 from "../image/rpsvector/rectangle1.png";

const ImpressiveSectionData = [
    { text: "Real-time Synchronization", icon: RectangleImage1 },
    { text: "Universal data format", icon: RectangleImage1 },
    { text: "STQC certified scanners", icon: RectangleImage1 },
    { text: "Robust & scalable", icon: RectangleImage1 },
  ];

export default ImpressiveSectionData;